import script from "./ConfirmActionDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmActionDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmActionDropdown.vue?vue&type=style&index=0&id=5cbd9322&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cbd9322"]])

export default __exports__